import { AutocompleteValue, BuildAutocompleteFilterUrlParams } from './ListPickAutocomplete.types';

export const LIMIT_LIST_PICK_AUTOCOMPLETE_TAGS = 200;

export const findIncludedOptions = <T,>(options: AutocompleteValue<T>, newIds: string[]) =>
  options.filter((item) => newIds?.includes(item.id));

export const buildAutocompleteFilterUrl = ({
  ids: values,
  url,
  idsAlias = 'ids',
}: BuildAutocompleteFilterUrlParams) => {
  const urlParams = new URLSearchParams();
  const ids = Array.isArray(values) ? values : [values];
  ids.forEach((id: string) => urlParams.append(idsAlias, id));
  urlParams.append('limit', LIMIT_LIST_PICK_AUTOCOMPLETE_TAGS.toString());
  return `${url}?${urlParams.toString()}`;
};
